import { Grid } from "@material-ui/core";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import { DISABLED_BUTTON_SUBMIT, instance4 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { useContext, useState } from "react";
import { FormContext } from "../context/FormContext";
import {
  STATUS_BARANG_OK,
  STATUS_BARANG_TOLAK,
  urlVerifikasiBarang,
} from "../helpers";
export default function ModalVerifikasi({
  formData,
  formVerifikasi,
  setFormVerifikasi,
  setNewDataReqList,
}) {
  const DEFAULT_BUTTON_OK = {
    label: "Setujui",
    color: "green",
    state: false,
    disabled: false,
  };

  const DEFAULT_BUTTON_TOLAK = {
    label: "Tolak",
    color: "danger",
    state: false,
    disabled: false,
  };
  const [disabledOK, setDisabledOK] = useState(DEFAULT_BUTTON_OK);
  const [disabledTolak, setDisabledTolak] = useState(DEFAULT_BUTTON_TOLAK);
  const { setShowModalVerifikasi } = useContext(FormContext);

  const handleChange = (text) => (e) => {
    setFormVerifikasi({
      ...formVerifikasi,
      [text]: e.target.value,
    });
  };

  const handleACCEPT = async (e) => {
    e.preventDefault();
    setDisabledOK(DISABLED_BUTTON_SUBMIT);
    if (isNull(formVerifikasi.id)) {
      defaultToastError("Harap pilih barang terlebih dahulu !");
      setShowModalVerifikasi(false);
      setDisabledOK(DEFAULT_BUTTON_OK);
    } else {
      try {
        const api = await instance4.post(urlVerifikasiBarang, {
          id: formVerifikasi.id,
          status_cek_barang: STATUS_BARANG_OK,
          keterangan_cek_barang: formVerifikasi.keterangan_cek_barang,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModalVerifikasi(false);
          defaultToastSuccess(res?.message);
          await setNewDataReqList(formData.idreq);
        }
      } catch (error) {
        setDisabledOK(DEFAULT_BUTTON_OK);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleTOLAK = async (e) => {
    e.preventDefault();
    setDisabledTolak(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formVerifikasi.id)) {
        defaultToastError("Harap pilih barang terlebih dahulu !");
        setShowModalVerifikasi(false);
        setDisabledTolak(DEFAULT_BUTTON_TOLAK);
      } else {
        try {
          const api = await instance4.post(urlVerifikasiBarang, {
            id: formVerifikasi.id,
            status_cek_barang: STATUS_BARANG_TOLAK,
            keterangan_cek_barang: formVerifikasi.keterangan_cek_barang,
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModalVerifikasi(false);
            defaultToastSuccess(res?.message);
            await setNewDataReqList(formData.idreq);
          }
        } catch (error) {
          setDisabledTolak(DEFAULT_BUTTON_TOLAK);
          defaultToastError(error?.response?.data?.message);
        }
      }
    } catch (error) {
      setDisabledTolak(DEFAULT_BUTTON_TOLAK);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <Modal
      title={`Verifikasi Barang`}
      show={setShowModalVerifikasi}
      width="50%"
    >
      <Grid container spacing={1}>
        <InputTextMaster
          type="hidden"
          name="barang_verifikasi"
          id="barang_verifikasi"
          readOnly={true}
          value={formVerifikasi?.id}
        />
        <Grid item sm={12}>
          <InputTextMaster
            name="namabarang_verifikasi"
            label="NAMA BARANG"
            id="namabarang_verifikasi"
            value={formVerifikasi?.name_barang}
            placeholder="Nama Barang"
            disabled={true}
            readOnly={true}
          />
        </Grid>
        <Grid item sm={6}>
          <InputTextMaster
            name="satuan_verifikasi"
            label="SATUAN"
            id="satuan_id"
            value={formVerifikasi?.namasatuan}
            placeholder="Satuan Barang"
            disabled={true}
            readOnly={true}
          />
        </Grid>
        <Grid item sm={6}>
          <InputTextMaster
            name="qty_verifikasi"
            label="BANYAK"
            id="qty_verifikasi"
            value={formVerifikasi?.qty}
            placeholder="Banyak"
            disabled={true}
            readOnly={true}
          />
        </Grid>
        <Grid item sm={12}>
          <InputTextMaster
            name="remarkBarang_verifikasi"
            label="Catatan Verifikasi Barang"
            id="remarkBarang_verifikasi"
            value={formVerifikasi?.keterangan_cek_barang}
            onChange={handleChange("keterangan_cek_barang")}
            placeholder="Catatan"
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <MasterButton
          outline={true}
          className={"mr-1 mt-1"}
          type={"button"}
          color={disabledTolak.color}
          name={disabledTolak.label}
          onClick={disabledTolak.disabled ? null : handleTOLAK}
          size="md"
        />
        <MasterButton
          className={"mt-1"}
          type={"button"}
          color={disabledOK.color}
          name={disabledOK.label}
          size="md"
          onClick={disabledOK.disabled ? null : handleACCEPT}
        />
      </Grid>
    </Modal>
  );
}
